import React from 'react';
import { summaryPoints } from '../../data/portfolio';
import './Summary.css';

function Summary() {
  return (
    <section className="summary-section" aria-label="핵심 경험">
      <div className="summary-grid">
        {summaryPoints.map((point) => (
          <article key={point.id}>
            <h2>{point.title}</h2>
            <p>{point.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Summary;
